exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dow6 {\r\n  display: none;\n}\n.dow0 {\r\n  display:none;\n}\n.cv-event.offset1{\r\n  left:20%\n}\n.cv-event.span1{\r\n  width: calc(20% - .05em)\n}\n.cv-event.offset2{\r\n  left:40%\n}\n.cv-event.span2{\r\n  width: calc(40% - .05em)\n}\n.cv-event.offset3{\r\n  left:60%\n}\n.cv-event.span3{\r\n  width: calc(60% - .05em)\n}\n.cv-event.offset4{\r\n  left:80%\n}\n.cv-event.span4{\r\n  width: calc(80% - .05em)\n}\r\n", ""]);

// exports
